"use strict";

function getCookieValue(cookieName) {
  var cookies = document.cookie.split("; ");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].split("=");
    if (cookie[0] === cookieName) {
      return cookie[1];
    }
  }
  return null;
}

const popinInfos = {
  init: function() {
    if (document.querySelector(".popinInfos")) {
      const popin = document.querySelector(".popinInfos");
      const closeBtn = document.querySelector(".js-popin-close");
      const openBtn = document.querySelector(".js-popin-open");
      const cta = document.querySelector(".popinInfos-link");
      let popinClicked = false;
      var date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);

      if (
        !getCookieValue(`keep-popin-closed-${current_blog}`) &&
        window.innerWidth > 767
      ) {
        console.log();
        setTimeout(() => {
          popin.classList.add("open");
        }, 5000);
      }

      closeBtn.addEventListener("click", () => {
        popin.classList.remove("open");
        /*AJOUT COOKIE CLOSE*/
        document.cookie = `keep-popin-closed-${current_blog}=${true}; expires=${date.toUTCString()}; path=/`;
      });

      cta.addEventListener("click", () => {
        popin.classList.remove("open");
        /*AJOUT COOKIE CLOSE*/
        document.cookie = `keep-popin-closed-${current_blog}=${true}; expires=${date.toUTCString()}; path=/`;
      });

      openBtn.addEventListener("click", () => {
        popin.classList.add("open");
        popinClicked = true;
        if (popinClicked && !openBtn.classList.contains("read")) {
          openBtn.classList.add("read");
        }
      });
    }
  },
};

export default popinInfos;



// WEBPACK FOOTER //
// ./src/scripts/components/popinInfos.js